<template>
  <div class="table-wrapper cover-content project-list">
    <!-- <high-search>  -->
    <Form
      ref="formInline"
      :model="formInline"
      inline
      class="form-list"
      :label-width="100"
      label-position="right"
    >
      <Row :gutter="16">
        <Col span="6">
          <FormItem label="项目名称:" prop="projectName" :label-width="78" >
            <Input
              v-model="formInline.projectName"
              placeholder="请输入项目名称"  clearable
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="项目状态:" prop="prjStatus" :label-width="150">
            <Select
              v-model="formInline.prjStatus"
              clearable
              placeholder="请选择项目状态"
            >
              <Option
                v-for="(item, index) in projectStatus"
                :value="item.code"
                :key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="实名制情况:" prop="sxRegState" :label-width="160">
            <RadioGroup v-model="formInline.sxRegState">
              <Radio :label="-1">全部</Radio>
              <Radio :label="1">已登记</Radio>
              <Radio :label="2">已对接</Radio>
               <Radio :label="3">已上传实名制数据</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="4" class="high-search">
          <Button type="primary" @click="handleQuery">搜索</Button>
          <Button style="margin-left: 20px" @click="handleReset">重置</Button>
          <span
            :class="open ? 'search-open' : 'search-close'"
            @click="open = !open"
            >{{ open ? "收起" : "展开" }}
            <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'"
          /></span>
        </Col>
      </Row>
      <Row :gutter="16" v-show="open">
        <Col span="6">
          <FormItem label="项目所在地（市/区）:" :label-width="150">
            <place-select v-model="formInline.areaCode"></place-select>

          </FormItem>
        </Col>
    <Col span="6">
          <FormItem label="供应商名称:" prop="supplierNames" :label-width="150">
            <Select
              v-model="formInline.supplierNames"
              placeholder="请选择供应商"
              filterable
              multiple
            >
              <Option
                v-for="(item, index) in Suppliers"
                :key="index"
                :label="item"
                :value="item"
                >{{ item }}</Option
              >
            </Select>
          </FormItem>
        </Col>
     <Col span="6">
          <FormItem label="删除状态:" prop="deleteStatus" :label-width="150">
            <Select
              v-model="formInline.deleteStatus"
              clearable
              placeholder="请选择"
            >
              <Option
                v-for="(item, index) in deleteStatusArr"
                :value="item.value"
                :key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="施工许可证号：" prop="builderLicenseNum">
            <Input v-model="formInline.builderLicenseNum" placeholder="请输入施工许可证号"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16" v-show="open">
        <Col span="6">
          <FormItem label="删除时间:" prop="WorkTime" :label-width="78">
            <DatePicker
              type="daterange"
              split-panels
              placeholder="请选择删除时间"
              :value="formInline.deleteTimeStringArr"
              @on-change="formInline.deleteTimeStringArr = $event"
              transfer
            ></DatePicker>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="项目Id:" :label-width="150">
            <Input
              v-model="formInline.projectId"
              placeholder="请输入项目Id" clearable
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="删除人:" :label-width="150">
            <Input
                    v-model="formInline.userName"
                    placeholder="请输入删除人" clearable
            ></Input>
          </FormItem>
        </Col>
      </Row>


    </Form>
    <!-- </high-search> -->
    <Table
      style="margin-top: 10px"
      border
      :loading="loading"
      :columns="tableColumns"
      :data="tableData"
      highlight-row
    >
      <template slot-scope="{ row, index }" slot="buildNumFlag">
        <div v-if="row.buildNumFlag == 1">已办理施工许可证</div>
        <div v-else>正在办理施工许可证</div>
      </template>
      <template slot-scope="{ row, index }" slot="startReportFlag">
        <div v-if="row.buildNumFlag != 1 && row.startReportFlag == 1">
          已办理开工报告
        </div>
        <div v-if="row.buildNumFlag != 1 && row.startReportFlag != 1">
          正在办理开工报告
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="userAccount">
        <div>{{row.userAccount}}</div>
        <div v-if="row.userName">（{{row.userName}}）</div>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <span
          class="pointer"
          style="margin-right: 8px"
          v-if="
            row.deleteStatusString === '未删除' &&
            $route.name === 'projectManagement'
          "
          @click="handleDealData( row.projectId)"
          >清除人员</span
        >
           <span
          v-if="
            row.deleteStatusString === '未删除'

          "
          style="margin-left: 8px"
          class="pointer"
          @click="handleDelete(row.projectId)"
          >删除项目</span
        >
        <span  style="margin-left: 8px"
          class="pointer"
          @click="handleDeal('projectDetail', row.projectId)"
          >详情</span
        >


      </template>
    </Table>
    <div class="t-page">
      <Page
        :total="totalCount"
        :page-size="pageSize"
        :current="page"
        @on-change="changePage"
        @on-page-size-change="pageSizeChange"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page>
    </div>
      <!-- <Modal
        v-model="modal1"
        title="Common Modal dialog box title"
        @on-ok="deleteProject"
        @on-cancel="cancel">
        <p>确定要删除项目吗</p>

    </Modal> -->
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { deletePageList } from '@/api/platform';
import tableMixin from '@/components/tableMixin';
export default {
  mixins: [tableMixin],
  data() {
    return {
      //删除项目弹出框
      // modal1:false,
      open: false,
      //删除状态
      deleteStatusArr:[
        {
          value:1,
          name:'已删除'
        },
        {
          value:0,
          name:'未删除'
        }
      ],
      formInline: {
          builderLicenseNum: '',
          userName: '',
        areaCode: localStorage.getItem('tenantAreaCode'),
        //项目名称：
        projectName: '',
        //项目分类：
        category: '',
        //施工单位：
        winUnit: '',
        //项目状态：
        prjStatus: '',

        //实名制状态：
        sxRegState: -1,

        //施工许可证办理情况 0全部1已办理2正在办理
        buildNumFlag: 0,
        //供应商名称
        supplierNames: [],

        startReportFlag: 0,
        deleteTimeStringArr :[],
        deleteTimeStartString:'',
        deleteTimeEndString:'',
        deleteStatus:'',
        projectId:''
      },
      tableColumns: [

        {
          title: '序号',
          type: 'index',
          width: 70,
          fixed: 'left',
          align: 'center',
        },
        {
          title: '项目名称',
          key: 'projectName',
          minWidth: 150,
          tooltip: true,
        },
        {
          title: '项目状态',
          key: 'prjStatus',
          minWidth: 80,
          tooltip: true,
        },
        {
          title: '项目类别',
          key: 'category',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '行政区划',
          key: 'areaName',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '实名制数据对接情况',
          key: 'sxRegState',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '施工许可证办理情况',
          slot: 'buildNumFlag',
          minWidth: 100,
          tooltip: true,
        },
          { title: "施工许可证号", key: 'builderLicenseNum', minWidth: 210, tooltip: true },
        {
          title: '施工单位',
          key: 'contractorCorpName',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '供应商名称',
          key: 'supplierName',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '删除状态',
          key: 'deleteStatusString',
          minWidth: 100,

        },
        {
          title: '删除时间',
          key: 'deleteTimeString',
          minWidth: 100,

        },
          {
              title: '删除人',
              slot: 'userAccount',
              minWidth: 100,
          },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 150,
        },
      ],
      tableData: [],
      exportData: {},
      Suppliers: [], // 供应商
    };
  },
  computed: {
    ...mapState(['area']),
    ...mapGetters(['projectStatus', 'projectCatetory']),
  },
  created() {
    this.$route.query.areaCode &&
      (this.formInline.areaCode = this.$route.query.areaCode);
    this.formInline.sxRegState = this.$route.query.sxRegState
      ? this.$route.query.sxRegState
      : -1;
    this.formInline.prjStatus = this.$route.query.prjStatus
      ? this.$route.query.prjStatus
      : '';
    this.getSuppliers();
  },
  mounted() {},
  watch: {},
  methods: {

    /*处理操作*/
    handleDelete(projectId) {
      this.$Modal.confirm({
        title: '提示',
        content: '确定要删除该项目吗？',
        onOk: () => {
          this.axios({
            method: 'get',
              url: `/project/deleteProjectById?projectId=${projectId}&userId=${localStorage.getItem('userId')}`,
          }).then((res) => {
            if (res.data.success) {
              this.$Message.success({
                content: '操作成功',
              });
              this.getTableData();
            } else {
              this.$Message.warning({
                content: '操作失败',
              });
            }
          });
        },
        onCancel: () => {},
      });
    },
    //删除人员得操作
    handleDealData(projectId){
      this.$Modal.confirm({
        title: '提示',
        content: '确定要删除该项目的人员吗？',
        onOk: () => {
          this.axios({
            method: 'get',
            url: `/project/emptyProjectWorkerByProjectId?projectId=${projectId}`,
          }).then((res) => {
            if (res.data.success) {
              this.$Message.success({
                content: '操作成功',
              });
              this.getTableData();
            } else {
              this.$Message.warning({
                content: '操作失败',
              });
            }
          });
        },
        onCancel: () => {},
      });
    },
    handleReset() {
      this.formInline = {
        areaCode: localStorage.getItem('tenantAreaCode'),
        //项目名称：
        projectName: '',
        //项目分类：
        category: '',
        //施工单位：
        winUnit: '',
        //项目状态：
        prjStatus: '',
        //实名制状态：
        sxRegState: -1,
        //施工许可证办理情况 0全部1已办理2正在办理
        buildNumFlag: 0,
        startReportFlag: 0,
        supplierNames: [],
        deleteTimeStringArr :[],
        deleteTimeStartString:'',
        deleteTimeEndString:'',
        deleteStatus:'',
        projectId:'',
          builderLicenseNum:''

      };
      this.getTableData();
    },
    //导出
    handleExport() {
      let param = {
        size: this.pageSize,
        current: this.page,
      };

      Object.assign(param, this.formInline);

      this.axios({
        method: 'post',
        url: '/project/export',
        responseType: 'arraybuffer',
        data: param,
      }).then((response) => {
        this.common.download(
          response,
          '项目数据.xls',
          'application/vnd.ms-excel'
        );
      });
    },
    /*处理操作*/
    handleDeal(name, projectId) {
      this.$router.push({
        name: name,
        query: {
          projectId: projectId,
        },
      });
    },

    /*获取供应商数据*/
    getSuppliers() {
      this.axios({
        method: 'post',
        url: '/supplier/queryAllSupplierNames',
        data: {
          areaCode: localStorage.getItem('tenantAreaCode'),
        },
      })
        .then((response) => {
          if (response.data.success) {
            this.Suppliers = response.data.data;
          }
        })
        .catch(() => {});
    },
    /*获取表格数据*/
    getTableData() {
        this.formInline.deleteTimeStartString = this.formInline.deleteTimeStringArr[0];
        this.formInline.deleteTimeEndString = this.formInline.deleteTimeStringArr[1];
        let param = {
            size: this.pageSize,
            current: this.page,
            ...this.formInline
        };
        delete param.deleteTimeStringArr;
        this.exportData = param;
        this.loading = true;

        deletePageList(param)
            .then((response) => {
                this.loading = false;
                if (response.data.success) {
                    this.totalCount = response.data.data.total;
                    this.tableData = response.data.data.records;
                }
            })
            .catch(() => {
                this.loading = false;
            });
    },
  },
};
</script>
